<payarc-page-header [title]="'Settings'"></payarc-page-header>

<div class="set-list">
  <payarc-section-card heading="Enable Swipe/EMV tokenization">
    <mat-slide-toggle [(ngModel)]="settings.tokenize" [disabled]="loadFlag" [color]="'primary'" (ngModelChange)="setTokenize()">Tokenize</mat-slide-toggle>
  </payarc-section-card>

  <app-kount></app-kount>

  <payarc-section-card heading="Enable Metadata columns to Transaction list">
    <mat-slide-toggle [(ngModel)]="settings.display_transactional_metadata" [disabled]="loadFlag" [color]="'primary'" (ngModelChange)="setMetadata()">Add Metadata</mat-slide-toggle>
  </payarc-section-card>

  <payarc-section-card heading="Disable Transaction Notifications Sent To Customer (Email)">
    <mat-slide-toggle [(ngModel)]="settings.disable_charge_notification_email" [disabled]="loadFlag" [color]="'primary'" (ngModelChange)="setChargeEmailNotification()">On</mat-slide-toggle>
  </payarc-section-card>

  <payarc-section-card heading="Disable Transaction Notifications Sent To Customer (SMS)">
    <mat-slide-toggle [(ngModel)]="settings.disable_charge_notification_sms" [disabled]="loadFlag" [color]="'primary'" (ngModelChange)="setChargeSmsNotification()">On</mat-slide-toggle>
  </payarc-section-card>

  <payarc-section-card heading="Enable ACH Notifications">
    <div class="set-stack">
      <mat-slide-toggle [(ngModel)]="settings.enable_ach_notifications_email" [disabled]="loadFlag" [color]="'primary'" (ngModelChange)="setAchEmailNotification()">Email</mat-slide-toggle>
      <mat-slide-toggle [(ngModel)]="settings.enable_ach_notifications_sms" [disabled]="loadFlag" [color]="'primary'" (ngModelChange)="setAchSmsNotification()">SMS</mat-slide-toggle>
    </div>
  </payarc-section-card>

  <payarc-section-card heading="Enable Chargeback Notifications">
    <div class="set-stack">
      <mat-slide-toggle [(ngModel)]="settings.enable_chargeback_notification_email" [disabled]="loadFlag" [color]="'primary'" (ngModelChange)="setChargebackEmailNotification()">Email</mat-slide-toggle>
      <mat-slide-toggle [(ngModel)]="settings.enable_chargeback_notification_sms" [disabled]="loadFlag" [color]="'primary'" (ngModelChange)="setChargebackSmsNotification()">SMS</mat-slide-toggle>
    </div>
  </payarc-section-card>

  <payarc-section-card heading="Enable Deposit Notifications">
    <div class="set-stack">
      <mat-slide-toggle [(ngModel)]="settings.enable_deposit_notification_email" [disabled]="loadFlag" [color]="'primary'" (ngModelChange)="setDepositEmailNotification()">Email</mat-slide-toggle>
      <mat-slide-toggle [(ngModel)]="settings.enable_deposit_notification_sms" [disabled]="loadFlag" [color]="'primary'" (ngModelChange)="setDepositSmsNotification()">SMS</mat-slide-toggle>
    </div>
  </payarc-section-card>

  <payarc-section-card heading="PayPal Settings" *ngIf="showPaypal">
    <div class="set-row"
         *ngIf="!dataManager['paypalStatus'] || (dataManager['paypalStatus']['internal_status'] !== 'boarded' &&
         dataManager['paypalStatus']['external_status'] !== 'ACTIVE'); else caseBoardedBlock">
      <button type="button" payarcButton="primary" *ngIf="!loadFlag" id="enablePaypal" (click)="enablePaypal()">
        Connect with <img [src]="paypalLogoUrl" alt="PayPal Logo" class="paypal-logo"/>
      </button>
      <div class="loader loader--style8" title="loading" *ngIf="loadFlag">
        <img src="../../../assets/images/uploading.svg">
      </div>
    </div>
    <ng-template #caseBoardedBlock>
      <span id="paypal-email-container" class="set-row">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#0070BA" viewBox="0 0 16 16"
             *ngIf="dataManager['paypalStatus'] && dataManager['paypalStatus']['internal_status'] === 'boarded'">
          <circle cx="8" cy="8" r="7" stroke="#0070BA" stroke-width="2" fill="white"/>
          <path fill="#0070BA" d="M6.75 8.75L5.5 7.5l-.75.75 2 2 4-4-.75-.75-3.25 3.25z"/>
        </svg>
        Your PayPal account is connected: {{ dataManager['paypalStatus']['email'] }}
        <button type="button" *ngIf="!dataManager['paypalStatus'] || (dataManager['paypalStatus']['is_embedded'] !== true)"
          class="set-link" (click)="enablePaypal(true)">(Unlink this profile and link new one)</button>
      </span>
    </ng-template>
    <payarc-inline-alert variant="bad" *ngIf="dataManager['paypalStatus'] && dataManager['paypalStatus']['primary_email_confirmed'] === false">
      Attention: Please confirm your email address on
      <a href="https://www.paypal.com/businessprofile/settings" target="_blank" rel="noopener noreferrer">https://www.paypal.com/businessprofile/settings</a>
      in order to receive payments! You currently cannot receive payments. Once done, simply revisit this page to refresh the onboarding status.
    </payarc-inline-alert>
    <payarc-inline-alert variant="bad" *ngIf="dataManager['paypalStatus'] && dataManager['paypalStatus']['payments_receivable'] === false">
      Attention: You currently cannot receive payments due to possible restriction on your PayPal account. Please reach out to PayPal Customer Support or connect to
      <a href="https://www.paypal.com" target="_blank" rel="noopener noreferrer">https://www.paypal.com</a>
      for more information. Once sorted, simply revisit this page to refresh the onboarding status.
    </payarc-inline-alert>
    <div class="set-stack mt-2">
      <mat-slide-toggle *ngIf="dataManager['paypalStatus'] && dataManager['paypalStatus']['internal_status'] === 'boarded'"
        [(ngModel)]="settings.enable_paypal_payments" [disabled]="loadFlag" [color]="'primary'" (ngModelChange)="setEnablePaypal()">
        <img [src]="paypalLogoUrl" alt="PayPal Logo" class="paypal-logo"/>
      </mat-slide-toggle>
      <mat-slide-toggle *ngIf="dataManager['paypalStatus'] && dataManager['paypalStatus']['internal_status'] === 'boarded'"
        [(ngModel)]="settings.enable_paypal_paylater" [disabled]="loadFlag || !settings.enable_paypal_payments" [color]="'primary'" (ngModelChange)="setEnablePaypalPaylater()">
        <img [src]="payLaterLogoUrl" alt="Pay Later Logo" class="paylater-logo"/>
      </mat-slide-toggle>
      <mat-slide-toggle *ngIf="dataManager['paypalStatus'] && dataManager['paypalStatus']['internal_status'] === 'boarded'"
        [(ngModel)]="settings.enable_paypal_venmo" [disabled]="loadFlag || !settings.enable_paypal_payments" [color]="'primary'" (ngModelChange)="setEnablePaypalVenmo()">
        <img [src]="venmoLogoUrl" alt="Venmo Logo" class="venmo-logo"/>
      </mat-slide-toggle>
    </div>
  </payarc-section-card>
</div>
